import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import Profile from './pages/Profile'
import Settings from './pages/Settings'
import Integrations from './pages/Integrations'
import Agencies from './pages/Agencies'
import CreateAgencyWizard from './pages/CreateAgencyWizard'
import AgencyProfile from './pages/AgencyProfile'
import AgencyJoin from './pages/AgencyJoin'
import Billing from './pages/Billing'
import Users from './pages/Users'
import UserDetails from './pages/UserDetails'
import Login from './pages/Login'
import Logout from './pages/Logout'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

function App() {
  return (
    <>
      <Routes>
        {/* Auth routes - not protected */}
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/logout" element={<Logout />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />

        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout>
              <Navigate to="/agencies" replace />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/integrations" element={
          <ProtectedRoute>
            <Layout>
              <Integrations />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Layout>
              <Settings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Layout>
              <Profile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/account" element={
          <ProtectedRoute>
            <Layout>
              <Profile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/billing" element={
          <ProtectedRoute>
            <Layout>
              <Billing />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/agencies" element={
          <ProtectedRoute>
            <Layout>
              <Agencies />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/agencies/create" element={
          <ProtectedRoute>
            <Layout>
              <CreateAgencyWizard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/agencies/:id" element={
          <ProtectedRoute>
            <Layout>
              <AgencyProfile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/agency/join/:agencyCode" element={
          <ProtectedRoute>
            <Layout>
              <AgencyJoin />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute>
            <Layout>
              <Users />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/users/:id" element={
          <ProtectedRoute>
            <Layout>
              <UserDetails />
            </Layout>
          </ProtectedRoute>
        } />
      </Routes>
    </>
  )
}

export default App